/**
 * What the member has done on Search Presence, kept across reloads for that member alone.
 */
export const useSearchPresenceStore = defineStore(
    'search-presence',
    () => {
        // The member has opened Search Presence, so the sidebar stops marking it new.
        const visited = ref(false);

        // The member dismissed the note that reputation and press content are out of scope.
        const pressNoteDismissed = ref(false);

        return { visited, pressNoteDismissed };
    },
    { persist: true }
);

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useSearchPresenceStore, import.meta.hot));
}
